/**
 * Header menu: ignore href="#" / "/#" so clicks don't scroll to top of page.
 * Works with overflow-list shadow DOM via composedPath().
 */
(function () {
  function isHashOnlyHref(href) {
    if (!href) return false;
    const value = href.trim();
    return value === '#' || value === '/#';
  }

  function isInHeader(path, anchor) {
    for (const node of path) {
      if (!(node instanceof Element)) continue;
      if (
        node.matches(
          'header-menu, header-drawer, header-component, #header-group, .header, header'
        )
      ) {
        return true;
      }
    }
    return Boolean(
      anchor.closest(
        'header-menu, header-drawer, header-component, #header-group, .header, header'
      )
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      const path =
        typeof event.composedPath === 'function' ? event.composedPath() : [];

      let anchor = null;
      for (const node of path) {
        if (node instanceof HTMLAnchorElement) {
          anchor = node;
          break;
        }
      }

      if (!anchor && event.target instanceof Element) {
        anchor = event.target.closest('a');
      }

      if (!anchor || !isHashOnlyHref(anchor.getAttribute('href'))) return;
      if (!isInHeader(path, anchor)) return;

      event.preventDefault();
    },
    true
  );
})();
